import React from 'react';
import "./Filterpart.css";
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import Form from 'react-bootstrap/Form';
import { useState } from 'react';
import FilterSidebar from "../Components/FilterSidebar";

export default function FilterPart() {
  const [open, setOpen] = useState(false);
  return (
    <div className="filter_main">
      <div className="container-fluid">
        <div className="row g-2">
           <div className="col-lg-4 col-md-4 col-sm-6 col-6">
           <button className="filter_btn"  onClick={() => setOpen(!open)}>
            <FilterAltOutlinedIcon />
            Filters By
           </button>
           </div>

            <FilterSidebar open={open} setOpen={setOpen} />
            
           <div className="col-lg-4 col-md-4 col-sm-12 col-12 d-lg-block d-md-block d-none">
            <div className="filter_product_title">
              <h2 className='text-center'>72 products</h2>
            </div>
           </div>

           <div className="col-lg-4 col-md-4 col-sm-6 col-6 d-flex justify-content-end">
             <Form.Select aria-label="Default select example">
            <option> SORT BY</option>
            <option value="1"> Newest</option>
            <option value="2"> Popular</option>
            <option value="3"> Discount</option>
            <option value="1">  Price : High to Low</option>
            <option value="2">  Price : Low to High</option>
            <option value="3">  Size : High to Low</option>
          </Form.Select>
           </div>
        </div>
        </div>
    </div>
  )
}
